(function () {
  var EXCLUDED_TAG = 'Loop-excluded';
  var STORAGE_KEY = 'jm_cart_has_fine';
  var tagCache = {};
  var currentRunId = 0;

  function apply(hasFine) {
    document.body.classList.toggle('cart-has-fine-product', hasFine);
    try { sessionStorage.setItem(STORAGE_KEY, hasFine ? '1' : '0'); } catch (_) {}

    // Loop Returns uses an open shadow root with no <slot>. Inject a style to
    // hide its UI and a slot to expose the light-DOM checkout button.
    document.querySelectorAll('checkout-plus').forEach(function (cp) {
      var sr = cp.shadowRoot;
      if (!sr) return;
      if (hasFine) {
        if (!sr.querySelector('#jm-fine-style')) {
          var style = document.createElement('style');
          style.id = 'jm-fine-style';
          style.textContent = '.dual-button-container,.loading-container{display:none!important}';
          sr.appendChild(style);
        }
        if (!sr.querySelector('#jm-fine-slot')) {
          var slot = document.createElement('slot');
          slot.id = 'jm-fine-slot';
          sr.appendChild(slot);
        }
      } else {
        ['#jm-fine-style', '#jm-fine-slot'].forEach(function (id) {
          var el = sr.querySelector(id);
          if (el) el.remove();
        });
      }
    });
  }

  function check() {
    var runId = ++currentRunId;

    fetch('/cart.js')
      .then(function (r) {
        if (!r.ok) throw new Error('cart fetch failed');
        return r.json();
      })
      .then(function (cart) {
        var items = cart.items || [];
        if (!items.length) {
          if (runId === currentRunId) apply(false);
          return;
        }

        var seen = {};
        var handles = items.map(function (i) { return i.handle; }).filter(function (h) {
          return h && !seen[h] && (seen[h] = true);
        });

        var pending = handles.filter(function (h) { return tagCache[h] === undefined; });
        Promise.all(pending.map(function (h) {
          return fetch('/products/' + h + '.js')
            .then(function (r) {
              if (!r.ok) throw new Error('product fetch failed');
              return r.json();
            })
            .then(function (p) {
              tagCache[h] = (p.tags || []).some(function (t) { return t.trim() === EXCLUDED_TAG; });
            })
            .catch(function () {}); // leave tagCache[h] undefined on failure = treated as excluded below
        })).then(function () {
          if (runId !== currentRunId) return;
          // Treat unresolved (undefined) conservatively — assume excluded
          apply(handles.some(function (h) { return tagCache[h] !== false; }));
        });
      })
      .catch(function () {});
  }

  // Apply cached state immediately to avoid a flash
  try { apply(sessionStorage.getItem(STORAGE_KEY) === '1'); } catch (_) {}

  // Re-inject whenever Rebuy re-renders a checkout-plus without our style
  new MutationObserver(function () {
    if (!document.body.classList.contains('cart-has-fine-product')) return;
    var needsInject = Array.from(document.querySelectorAll('checkout-plus')).some(function (cp) {
      return cp.shadowRoot && !cp.shadowRoot.querySelector('#jm-fine-style');
    });
    if (needsInject) apply(true);
  }).observe(document.body, { childList: true, subtree: true });

  // Run on load and on any cart update event
  document.addEventListener('DOMContentLoaded', check);
  ['cart:updated', 'rebuy:cart.change', 'rebuy:cart.add'].forEach(function (e) {
    document.addEventListener(e, check);
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') check();
  });
})();
